// 游戏常量
export const GAME_CONSTANTS = {
  // GCD相关
  DEFAULT_GCD: 2.5,
  MIN_GCD: 1.0,
  MAX_GCD: 5.0,
  
  // 连击相关
  DEFAULT_COMBO_WINDOW: 30, // 秒
  
  // 角色状态相关
  DEFAULT_CHARACTER_ACTIVE_DURATION: 1000, // 毫秒
  
  // 战斗相关
  COMBAT_TIMEOUT: 15000, // 15秒无操作退出战斗状态
  
  // 积蓄相关
  DEFAULT_CONSUME_INTERVAL: 1.5, // 秒
} as const;

// UI常量
export const UI_CONSTANTS = {
  ACTION_BAR_SLOTS: 12,
  ACTION_BAR_COUNT: 3,
} as const;